@if (!pending) {
    @if (displayEntities?.data.length > 0) {
        <div>
            <table class="table w-100 bg-light" mat-table matSort [dataSource]="displayEntities">
                <ng-container matColumnDef="loadDate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'ui.history-table.date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">
                        {{ upload.loadDate | date: calendarFormat }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="fileName">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.file' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.fileName }}</td>
                </ng-container>

                <ng-container matColumnDef="operType">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'ui.history-table.op' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.operType }}</td>
                </ng-container>

                <ng-container matColumnDef="trfName">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.ticket' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let upload">{{ upload.trfName }}</td>
                </ng-container>

                <ng-container matColumnDef="hasError">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'global.labels.status' | translate }}
                    </th>

                    <td mat-cell *matCellDef="let upload">
                        <span [class.text-success]="upload.hasError === 0" [class.text-danger]="upload.hasError > 0">
                            @if (upload.hasError === 0) {
                                <span>{{ 'ui.table-uploads.status.success' | translate }}</span>
                            }
                            @if (upload.hasError > 0) {
                                <span>{{ 'ui.table-uploads.status.fail' | translate }}</span>
                            }
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="link">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'ui.table-uploads.status.fail' | translate }}
                    </th>

                    <td mat-cell *matCellDef="let upload">
                        @if (upload.hasError > 0) {
                            <a class="a--border-off a--danger" rel="noopener" target="_blank" [attr.href]="upload | urlLoadReport | async">
                                <ui-icon-bs [type]="bsIconTypes.FileEarmarkText" />
                            </a>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr class="tr--cursor-default" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    } @else {
        <ui-no-matches />
    }
} @else {
    <ui-pre-loader [narrow]="true" />
}
<paginator [source]="displayEntities" />
